import { render, staticRenderFns } from "./bac-activity.vue?vue&type=template&id=fe863e92&"
import script from "./bac-activity.vue?vue&type=script&lang=js&"
export * from "./bac-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports